import state from './moduleLanguagesState'
import mutations from './moduleLanguagesMutations'
import actions from './moduleLanguagesActions'
import getters from './moduleLanguagesGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}